<template>
    <div>
        <breadcrumbs
            :title="'Porezi'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Novi porez</h5>
            </div>
            <div class="ibox-content">
                <porez-forma
                    :disabled="false"
                    :id="null"
                    :modal="false"
                    :action="'create'"
                ></porez-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import PorezForma from "./PorezForma";
export default {
    name: "PorezCreate",
    components: {
        PorezForma,
        Breadcrumbs
    },
    data(){
        return {
            breadcrumbs: []
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/porezi',
                    name: 'Porezi'
                },
                {
                    path: '/postavke/porezi/create',
                    name: 'Novi porez'
                }
            ]
        }
    },
    mounted() {
        this.setBreadcrumbs()
    }
};

</script>

<style scoped>

</style>
